export const ROWS4X4 = [[0, 1, 2, 3], [4, 5, 6, 7,], [8, 9, 10, 11], [12, 13, 14, 15]]
export const COLS4X4 = [[0, 4, 8, 12],[1, 5, 9, 13], [2, 6, 10, 14], [3, 7, 11, 15]]
export const GROUPS4X4 = [[0, 1, 4, 5], [2, 3, 6, 7], [8, 9, 12, 13], [10, 11, 14, 15]]
export const ROWS9X9 = [
  [0,1,2,3,4,5,6,7,8],
  [9,10,11,12,13,14,15,16,17],
  [18,19,20,21,22,23,24,25,26],
  [27,28,29,30,31,32,33,34,35],
  [36,37,38,39,40,41,42,43,44],
  [45,46,47,48,49,50,51,52,53],
  [54,55,56,57,58,59,60,61,62],
  [63,64,65,66,67,68,69,70,71],
  [72,73,74,75,76,77,78,79,80]
]
export const COLS9X9 = [
  [0,9,18,27,36,45,54,63,72],
  [1,10,19,28,37,46,55,64,73],
  [2,11,20,29,38,47,56,65,74],
  [3,12,21,30,39,48,57,66,75],
  [4,13,22,31,40,49,58,67,76],
  [5,14,23,32,41,50,59,68,77],
  [6,15,24,33,42,51,60,69,78],
  [7,16,25,34,43,52,61,70,79],
  [8,17,26,35,44,53,62,71,80]
]
export const GROUPS9X9 = [
  [0, 1, 2, 9, 10, 11, 18, 19, 20],
  [3, 4, 5, 12, 13, 14, 21, 22, 23],
  [6, 7, 8, 15, 16, 17, 24, 25, 26],
  [27, 28, 29, 36, 37, 38, 45, 46, 47],
  [30, 31, 32, 39, 40, 41, 48, 49, 50],
  [33, 34, 35, 42, 43, 44, 51, 52, 53],
  [54, 55, 56, 63, 64, 65, 72, 73, 74],
  [57, 58, 59, 66, 67, 68, 75, 76, 77],
  [60, 61, 62, 69, 70, 71, 78, 79, 80]
]
export const ROWS16X16 = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
  [32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
  [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63],
  [64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  [80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95],
  [96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111],
  [112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127],
  [128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143],
  [144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159],
  [160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175],
  [176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191],
  [192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207],
  [208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223],
  [224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239],
  [240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]
]
export const COLS16X16 = [
  [0, 16, 32, 48, 64, 80, 96, 112, 128, 144, 160, 176, 192, 208, 224, 240],
  [1, 17, 33, 49, 65, 81, 97, 113, 129, 145, 161, 177, 193, 209, 225, 241],
  [2, 18, 34, 50, 66, 82, 98, 114, 130, 146, 162, 178, 194, 210, 226, 242],
  [3, 19, 35, 51, 67, 83, 99, 115, 131, 147, 163, 179, 195, 211, 227, 243],
  [4, 20, 36, 52, 68, 84, 100, 116, 132, 148, 164, 180, 196, 212, 228, 244],
  [5, 21, 37, 53, 69, 85, 101, 117, 133, 149, 165, 181, 197, 213, 229, 245],
  [6, 22, 38, 54, 70, 86, 102, 118, 134, 150, 166, 182, 198, 214, 230, 246],
  [7, 23, 39, 55, 71, 87, 103, 119, 135, 151, 167, 183, 199, 215, 231, 247],
  [8, 24, 40, 56, 72, 88, 104, 120, 136, 152, 168, 184, 200, 216, 232, 248],
  [9, 25, 41, 57, 73, 89, 105, 121, 137, 153, 169, 185, 201, 217, 233, 249],
  [10, 26, 42, 58, 74, 90, 106, 122, 138, 154, 170, 186, 202, 218, 234, 250],
  [11, 27, 43, 59, 75, 91, 107, 123, 139, 155, 171, 187, 203, 219, 235, 251],
  [12, 28, 44, 60, 76, 92, 108, 124, 140, 156, 172, 188, 204, 220, 236, 252],
  [13, 29, 45, 61, 77, 93, 109, 125, 141, 157, 173, 189, 205, 221, 237, 253],
  [14, 30, 46, 62, 78, 94, 110, 126, 142, 158, 174, 190, 206, 222, 238, 254],
  [15, 31, 47, 63, 79, 95, 111, 127, 143, 159, 175, 191, 207, 223, 239, 255]
]
export const GROUPS16X16 = [
  [0, 1, 2, 3, 16, 17, 18, 19, 32, 33, 34, 35, 48, 49, 50, 51],
  [4, 5, 6, 7, 20, 21, 22, 23, 36, 37, 38, 39, 52, 53, 54, 55],
  [8, 9, 10, 11, 24, 25, 26, 27, 40, 41, 42, 43, 56, 57, 58, 59],
  [12, 13, 14, 15, 28, 29, 30, 31, 44, 45, 46, 47, 60, 61, 62, 63],
  [64, 65, 66, 67, 80, 81, 82, 83, 96, 97, 98, 99, 112, 113, 114, 115],
  [68, 69, 70, 71, 84, 85, 86, 87, 100, 101, 102, 103, 116, 117, 118, 119],
  [72, 73, 74, 75, 88, 89, 90, 91, 104, 105, 106, 107, 120, 121, 122, 123],
  [76, 77, 78, 79, 92, 93, 94, 95, 108, 109, 110, 111, 124, 125, 126, 127],
  [128, 129, 130, 131, 144, 145, 146, 147, 160, 161, 162, 163, 176, 177, 178, 179],
  [132, 133, 134, 135, 148, 149, 150, 151, 164, 165, 166, 167, 180, 181, 182, 183],
  [136, 137, 138, 139, 152, 153, 154, 155, 168, 169, 170, 171, 184, 185, 186, 187],
  [140, 141, 142, 143, 156, 157, 158, 159, 172, 173, 174, 175, 188, 189, 190, 191],
  [192, 193, 194, 195, 208, 209, 210, 211, 224, 225, 226, 227, 240, 241, 242, 243],
  [196, 197, 198, 199, 212, 213, 214, 215, 228, 229, 230, 231, 244, 245, 246, 247],
  [200, 201, 202, 203, 216, 217, 218, 219, 232, 233, 234, 235, 248, 249, 250, 251],
  [204, 205, 206, 207, 220, 221, 222, 223, 236, 237, 238, 239, 252, 253, 254, 255]
]

export const getCellGroups = (size) => {
  switch(size) {
    case 4:
      return {
        rows: ROWS4X4,
        cols: COLS4X4,
        groups: GROUPS4X4,
      }
    case 9:
      return {
        rows: ROWS9X9,
        cols: COLS9X9,
        groups: GROUPS9X9,
      }
    case 16:
      return {
        rows: ROWS16X16,
        cols: COLS16X16,
        groups: GROUPS16X16
      }
    default:
      return {};
  }
}

export const getHighlightedFromIndex = (index, size) => {
  const nextHighlighted = new Set();

  if (index === undefined || index === null) {
    return nextHighlighted;
  }
  const column = index % size;
  const row = Math.floor(index / size);
  const groupSize = Math.sqrt(size);
  const group = (Math.floor(row/groupSize) * groupSize) + Math.floor(column/groupSize);

  function addEachCell(value) {
    nextHighlighted.add(value);
  }

  switch(size) {
    case 4:
      ROWS4X4[row].forEach(addEachCell)
      COLS4X4[column].forEach(addEachCell)
      GROUPS4X4[group].forEach(addEachCell)
      break;
    case 9:
      ROWS9X9[row].forEach(addEachCell)
      COLS9X9[column].forEach(addEachCell)
      GROUPS9X9[group].forEach(addEachCell)
      break;
    case 16:
      ROWS16X16[row].forEach(addEachCell)
      COLS16X16[column].forEach(addEachCell)
      GROUPS16X16[group].forEach(addEachCell)
      break;
    default:
      return nextHighlighted;
  }
  return nextHighlighted;
}

export const getConflicts = (board, size) => {
  const cellGroups = getCellGroups(size);
  const conflicts = [];
  Object.values(cellGroups).forEach((groupType) => { // Row, Col, Group
    groupType.forEach((group) => {
      const testSet = [];
      const tempConflicts = new Set();
      group.forEach((cellIndex) => {
        const cellValue = board[cellIndex];
        if (!cellValue) {
          return;
        }
        if (testSet[cellValue]) {
          testSet[cellValue].push(cellIndex);
          tempConflicts.add(cellValue);
        }
        else {
          testSet[cellValue] = [cellIndex];
        }
      });
      tempConflicts.forEach((conflict) => {
        conflicts.push(...testSet[conflict]);
      });
    });
  });
  return conflicts;
}

export const getInitBoard = (data, size) => {
  switch (size) {
    case 9:
      return data.initBoard9x9;
    case 16:
      return data.initBoard16x16;
    case 4:
    default:
      return data.initBoard4x4;
  }
}

export const getBoardFromData = (data, size) => {
  switch (size) {
    case 9:
      return data.board9x9;
    case 16:
      return data.board16x16;
    case 4:
    default:
      return data.board4x4;
  }
}

export const setBoardWithData = (data, nextBoard) => {
  switch (data.size) {
    case 9:
      data.board9x9 = nextBoard;
      break;
    case 16:
      data.board16x16 = nextBoard;
      break;
    case 4:
    default:
      data.board4x4 = nextBoard;
  }
}

export const getPossibleNums = (nextBoard, size) => {
  const cellGroups = getCellGroups(size);
  const possibleNums = [];
  const ALL_POSSIBLE_NUMS = [...Array(size).keys()].map(i => i + 1);

  for (let i = 0; i < nextBoard.length; i++) {
    possibleNums[i] = [];
    if (nextBoard[i] !== 0) {
      continue;
    }

    const rowNum = Math.floor(i / size);
    const row = cellGroups.rows[rowNum];
    const colNum = i % size;
    const col = cellGroups.cols[colNum];
    const root = Math.sqrt(size);
    const groupNum = (Math.floor(rowNum / root) * root) + Math.floor(colNum / root);
    const group = cellGroups.groups[groupNum];

    const indicies = new Set([...row, ...col, ...group]);
    possibleNums[i] = new Set([...ALL_POSSIBLE_NUMS]);
    indicies.forEach((index) => {
      possibleNums[i].delete(nextBoard[index]);
    })
    possibleNums[i] = [...possibleNums[i]];
  }
  return possibleNums;
}